<div id="main-content" class="wrapper has-padding margin-height zoom-margin" (focusout)="onFocusOutMainContent($event)">
  <form *ngIf="educationData ;  else loading" [formGroup]="educationGroup" (ngSubmit)="onSubmit()">

    <h1 #target class="bofa--heading is-4">Education history</h1>
    <p class="global-red">{{educationInstruction}} </p>
    <p *ngIf="educationData.usTrustBioEmail == '0'"><strong>Please note: In preparation for future public biography submissions, please include ALL education
        completed/attempted that you would like to include in your public biography.</strong></p>
    <div *ngIf="educationData.degreeRequiredFlag == '-1'">
      <p>
        <mat-checkbox formControlName="noEducationHistory" class="minor-check-padding">I have no education history to
          list.</mat-checkbox>
      </p>
    </div>
    <div *ngIf="!noEducationHistory.value" class="flex-container bottom-space">

      <div class="fx-flex-40">
        <div class="is-taller">
          <div class="level">
            <div class="level-item">
              <h2 class="bofa--heading is-6 flex-heading">Enter your education history</h2>
            </div>
          </div>
        </div>

        <div *ngFor="let educationForm of educationList.controls; let i = index" [formGroup]="educationForm">
          <div>
            <mat-accordion multi="true" *ngIf="step === i">
              <mat-expansion-panel [class.border]="border" [expanded]="step === i" [hideToggle]="true"
                (opened)="setStep(i)" class="af-mat-card mat-elevation-z panel-width">
                <mat-expansion-panel-header class="mat-expansion outlined background-color_rgba_237_237_237_1">
                  <mat-panel-title>
                    Educational institution {{i+1}}
                  </mat-panel-title>
                  <mat-panel-description>
                    <div class="float_right_cursor_pointer_margin-left_auto"><img role="button" tabindex="0"
                        (keyup.enter)="deleteClick(i)" (click)="deleteClick(i)" src="assets/bofa_icon_close2_186rgb.svg"
                        class="height-Width_20" alt="Remove education institution" /></div>
                  </mat-panel-description>
                </mat-expansion-panel-header>

                <!-- set focus when pressing Add button -->
                <div tabindex="-1" #addEducationElement class="bofa--skiplink">
                </div>

                <p class="bofa--heading is-8 bold ">(1 of {{count}}) General information</p>

                <mat-form-field class="max-width max-zoom minor-list-space width_350" 
                  hideRequiredMarker>
                  <mat-label><abbr title="required">* </abbr>Name of institution</mat-label>
                  <input matInput formControlName="educationInstitutionName" required>
                  <mat-error>Please enter a valid Name of institution</mat-error>
                </mat-form-field>

                <mat-form-field class="max-width minor-list-space width_350" hideRequiredMarker>
                  <mat-label><abbr title="required">* </abbr>Type of institution</mat-label>
                  <mat-select formControlName="educationInstitutionType" required>
                    <mat-option>Select</mat-option>
                    <mat-option
                      *ngFor="let educationInstitutionType of educationData.typeOfEducationInstLookup | keyvalue : valueAscOrderOtherLast"
                      [value]="educationInstitutionType.key">
                      {{educationInstitutionType.value}}
                    </mat-option>
                  </mat-select>
                  <mat-hint class="bofa--skiplink">
                    <!-- Hidden for screen readers so it reads the current value selected from the dropdown -->
                    {{ dropDownScreenReaderInstitution(educationForm) }}
                  </mat-hint>
                  <mat-error *ngIf="educationForm.controls.educationInstitutionType.hasError('required') ">Please select
                    Type of institution
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="max-width max-zoom minor-list-space width_350"
                  hideRequiredMarker>
                  <mat-label><abbr title="required">* </abbr>Course of study</mat-label>
                  <input matInput formControlName="course" required>
                  <mat-error>Please enter a valid Course of study</mat-error>
                </mat-form-field>

                <span class="mat-hint-italic margin-notop minor-list-space">This is the field of study your degree or
                  program focused on..
                  <ul class="has-no-padding has-no-margin">
                    <li><strong>Have multiple areas of focus?</strong> List those that were considered your majors.</li>
                  </ul>
                </span>

                <mat-form-field class="max-width minor-list-space width_350p_margin-top_5em"
                  hideRequiredMarker>
                  <mat-label><abbr title="required">* </abbr>Type of degree/diploma</mat-label>
                  <mat-select formControlName="degreeType" required>
                    <mat-option>Select</mat-option>
                    <mat-option
                      *ngFor="let degreeType of educationData.typeOfDegreeLookup | keyvalue : valueAscOrderOtherLast"
                      [value]="degreeType.key">
                      {{degreeType.value}}
                    </mat-option>
                  </mat-select>
                  <mat-hint class="bofa--skiplink">
                    <!-- Hidden for screen readers so it reads the current value selected from the dropdown -->
                    {{ dropDownScreenReaderDegree(educationForm) }}
                  </mat-hint>
                  <mat-error *ngIf="educationForm.controls.degreeType.hasError('required') ">Please select Type of
                    degree/diploma
                  </mat-error>
                </mat-form-field>
                <div class="bottom-space" *ngIf="jobCountry == 'IND'">
                  <div class="grey-bg">
                    <p><strong><abbr title="required">* </abbr>At least one of the following is required:</strong></p>
                    <mat-form-field class="max-width width_310" >
                      <mat-label>Final Year Enrollment Number</mat-label>
                      <input matInput formControlName="enrollmentNumber" (keypress)="allowOnlyAlphaNumeric($event)">
                      <mat-error>Please enter a valid Enrollment Number</mat-error>
                    </mat-form-field>

                    <mat-form-field class="max-width width_310" >
                      <mat-label>Final Year Seat Number</mat-label>
                      <input matInput formControlName="seatNumber" (keypress)="allowOnlyAlphaNumeric($event)">
                      <mat-error>Please enter a valid Seat Number</mat-error>
                    </mat-form-field>

                    <mat-form-field class="max-width width_310" >
                      <mat-label>Final Year Registration Number</mat-label>
                      <input matInput formControlName="registrationNumber" (keypress)="allowOnlyAlphaNumeric($event)">
                      <mat-error>Please enter a valid Registration Number</mat-error>
                    </mat-form-field>

                    <mat-error *ngIf="(educationForm.controls?.enrollmentNumber?.touched && !educationForm.controls?.enrollmentNumber?.value) &&
                    (educationForm.controls?.seatNumber?.touched && !educationForm.controls?.seatNumber?.value) &&
                    (educationForm.controls?.registrationNumber?.touched && !educationForm.controls?.registrationNumber?.value)">
                      Please enter at least one of the above field
                    </mat-error>
                  </div>
                </div>
                <div class="non-required">
                  <mat-form-field class="max-width width_310" >
                    <mat-label>GPA (optional)</mat-label>
                    <input matInput formControlName="gradeGpa">
                    <mat-error>Please enter a valid GPA</mat-error>
                  </mat-form-field>
                </div>

                <div class="non-required">
                  <mat-form-field class="max-width width_310" >
                    <mat-label>
                      Your name while in attendance (optional)</mat-label>
                    <input matInput formControlName="nameWhileAttending">
                    <mat-error>Please enter a valid Name</mat-error>
                  </mat-form-field>
                </div>

                <div class="non-required-textarea">
                  <mat-form-field class="width_310">
                    <mat-label id="comments-label">Comments (optional)</mat-label>
                    <textarea matInput formControlName="commt" maxlength="1000" aria-labelledby="comments-label"></textarea>
                    <mat-hint align="end">
                      {{(educationForm.controls.commt.value)?educationForm.controls.commt.value.length:0}} / 1000
                    </mat-hint>
                    <mat-error>Please enter a valid Comment</mat-error>
                  </mat-form-field>
                </div>

                <p class="bofa--heading is-8 bold ">(2 of {{count}}) Location information</p>

                <div *ngIf="educationData.lockBoxFlag != '-1'">
                  <mat-form-field class="max-width max-zoom minor-list-space width_350" 
                    hideRequiredMarker>
                    <mat-label><abbr title="required">* </abbr>Street Address 1</mat-label>
                    <input matInput formControlName="eduInstStreetAddress1" required>
                    <mat-error>Please enter a valid Street Address 1</mat-error>
                  </mat-form-field>
                  <div class="non-required middle-width minor-list-space">
                    <mat-form-field class="max-width width_310" >
                      <mat-label>
                        Street Address 2</mat-label>
                      <input matInput formControlName="eduInstStreetAddress2">
                      <mat-error>Please enter a valid Street Address 2</mat-error>
                    </mat-form-field>
                  </div>

                  <div class="non-required middle-width minor-list-space">
                    <mat-form-field class="max-width width_310">
                      <mat-label>
                        Street Address 3</mat-label>
                      <input matInput formControlName="eduInstStreetAddress3">
                      <mat-error>Please enter a valid Street Address 3</mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <mat-form-field class="max-width max-zoom minor-list-space width_350" 
                  hideRequiredMarker>
                  <mat-label><abbr title="required">* </abbr>Institution Zip/Postal code</mat-label>
                  <input matInput formControlName="educationInstitutionZip" required>
                  <mat-error>Please enter a valid Institution Zip/Postal code
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="max-width max-zoom minor-list-space width_350" 
                  hideRequiredMarker>
                  <mat-label><abbr title="required">* </abbr>Institution City/Town/Province</mat-label>
                  <input matInput formControlName="educationInstitutionCity" required>
                  <mat-error>Please enter a valid Institution City/Town/Province
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="max-width max-zoom minor-list-space width_350"  hideRequiredMarker>
                  <mat-label><abbr title="required">* </abbr>Institution Country</mat-label>
                  <mat-select formControlName="educationInstitutionCountry" required>
                    <mat-option>Select</mat-option>
                    <mat-option
                      *ngFor="let educationInstitutionCountry of educationData.countryLookup | keyvalue : valueAscOrder"
                      [value]="educationInstitutionCountry.key">
                      {{educationInstitutionCountry.value}}
                    </mat-option>
                  </mat-select>
                  <mat-hint class="bofa--skiplink">
                    <!-- Hidden for screen readers so it reads the current value selected from the dropdown -->
                    {{ dropDownScreenReaderCountry(educationForm) }}
                  </mat-hint>
                  <mat-error *ngIf="educationForm.controls.educationInstitutionCountry.hasError('required') ">Please
                    select Institution Country
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="max-width minor-list-space"
                  *ngIf="educationForm.controls.educationInstitutionCountry.value ==186" class="width_350"
                  hideRequiredMarker>
                  <mat-label><abbr title="required">* </abbr>Institution State</mat-label>
                  <mat-select formControlName="educationInstitutionUsState" required>
                    <mat-option>Select</mat-option>
                    <mat-option *ngFor="let us of educationData.usStateLookup | keyvalue : valueAscOrder"
                      [value]=us.key>
                      {{us.value}}
                    </mat-option>
                  </mat-select>
                  <mat-hint class="bofa--skiplink">
                    <!-- Hidden for screen readers so it reads the current value selected from the dropdown -->
                    {{ dropDownScreenReaderState(educationForm) }}
                  </mat-hint>
                  <mat-error *ngIf="educationForm.controls.educationInstitutionUsState.hasError('required') ">Please
                    select Institution State
                  </mat-error>
                </mat-form-field>

                <div *ngIf="educationForm.controls.educationInstitutionCountry.value !=186">
                  <mat-form-field class="max-width max-zoom minor-list-space width_350" 
                    hideRequiredMarker>
                    <mat-label><abbr title="required">* </abbr>Institution State/Province</mat-label>
                    <input matInput formControlName="educationInstitutionState" required>
                    <mat-error>Please enter a valid State/Province</mat-error>
                  </mat-form-field>
                </div>

                <p class="bofa--heading is-8 bold ">(3 of {{count}}) Final details</p>
                <mat-form-field class="max-width minor-list-space"  class="width_350" hideRequiredMarker>
                  <mat-label><abbr title="required">* </abbr>Did you complete all the
                    requirements for your course of study/degree?</mat-label>
                  <mat-select formControlName="isCompleted" required>
                    <mat-option>Select</mat-option>
                    <mat-option   value=1> Received Degree</mat-option>
                    <mat-option   value=0> Attended Only (No Degree)</mat-option>
                    <mat-option   value=2> Currently Attending</mat-option>
                  </mat-select>
                  <mat-error *ngIf="educationForm.controls.isCompleted.hasError('required') ">Please
                    select Requirements for your course of study/degree
                  </mat-error>
                </mat-form-field>

          
                <div class="bottom-space">
                  <label id="degreeCopy-radio-group-label" for="degreeCopy-radio-group"><abbr title="required">* </abbr>Could you provide us a copy
                    of your degree or certificate of completion, if requested?</label>
                  <mat-radio-group
                    id="degreeCopy-radio-group"
                    (focusout)="copyOnBlur(i)" (focusin)="copyOnFocus(i)"
                    aria-describedby="degreeCopy-radio-group-label" formControlName="degreeCopy" required
                    class="bottom-space" aria-required="true">
                    <mat-radio-button class="minor-list-space radio-padding field-space" value="1" name="degreeCopy">Yes
                    </mat-radio-button>
                    <mat-radio-button value="0" name="degreeCopy">No</mat-radio-button>
                    <mat-error
                      *ngIf="(submit.value && educationForm.controls.degreeCopy.hasError('required')) || educationForm.controls.radioCheckTwo.value">
                      Please select Could you provide us a copy of your degree or certificate of completion, if
                      requested?
                    </mat-error>
                  </mat-radio-group>

                  <!-- Hidden divs are for screen readers -->
                  <div class="bofa--skiplink">
                    <mat-error
                      *ngIf="submit.value && educationForm.controls.degreeCopy.hasError('required') && educationForm.controls.radioCheckTwo.value">
                      Please select Could you provide us a copy of your degree or certificate of completion, if
                      requested?? </mat-error>
                  </div>
                </div>

                <mat-form-field class="max-width bottom-space width_350"  hideRequiredMarker>
                  <mat-label> <abbr title="required">* </abbr>Date attendance began</mat-label>
                  <input matInput [matDatepicker]="educationStartDatePicker" [min]="minDate" [max]="maxDate"
                    formControlName="educationStartDate" required>
                  <mat-datepicker-toggle matSuffix [for]="educationStartDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #educationStartDatePicker></mat-datepicker>
                  <mat-hint>Format mm/dd/yyyy</mat-hint>
                  <mat-error *ngIf="educationForm.controls.educationStartDate.errors">Please enter valid Date attendance
                    began
                  </mat-error>
                </mat-form-field>

                <div class="bottom-space">
                  <mat-form-field class="max-width width_350"  hideRequiredMarker>
                    <mat-label> <abbr title="required">* </abbr>Date attendance ended</mat-label>
                    <input matInput [matDatepicker]="endDatePicker" [min]="minDate" [max]="maxDate"
                      formControlName="educationEndDate" required>
                    <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #endDatePicker></mat-datepicker>
                    <mat-hint>Format mm/dd/yyyy</mat-hint>
                    <mat-error *ngIf="educationForm.controls.educationEndDate.errors">Please enter valid Date attendance
                      ended
                    </mat-error>
                  </mat-form-field>

                  <span class="mat-hint-italic margin-notop">This is the last date you attended the school or
                    program.<br />
                    <ul class="has-no-padding has-no-margin">
                      <li><strong>Still attending class?</strong> Select the current date.</li>
                      <li><strong>Can't remember this date?</strong> Select the first day of the month in the year you
                        got your degree.</li>
                    </ul>
                  </span>
                </div>

            <div *ngIf="educationForm.controls.isCompleted.value  != 0"> 
                <mat-form-field  class="max-width width_350"  hideRequiredMarker>
                  <mat-label> <abbr title="required">* </abbr>Actual/anticipated graduation date</mat-label>
                  <input matInput [matDatepicker]="graduationDatePicker" formControlName="graduationDate" required>
                  <mat-datepicker-toggle matSuffix [for]="graduationDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #graduationDatePicker></mat-datepicker>
                  <mat-hint>Format mm/dd/yyyy</mat-hint>
                  <mat-error *ngIf="educationForm.controls.graduationDate.errors">Please enter valid Actual/anticipated
                    graduation date
                  </mat-error>
                </mat-form-field>
                

                <span class="mat-hint-italic margin-notop">This can be a future date for anticipated graduation.<br />
                  <ul class="has-no-padding has-no-margin">
                    <li><strong>Did not finish your course?</strong> Select the date you last attended the institution.
                    </li>
                    <li><strong>Can't remember this date?</strong> Select the first day of the month in the year you got
                      your degree.</li>
                  </ul>
                </span>
              </div>
                <ng-template #notRequiredGrduationDate>
                  <p class="non-required-textarea minor-list-space">
                    <mat-form-field class="height_120px_width_310">
                      <mat-label> Actual/anticipated graduation date</mat-label>
                      <input matInput [matDatepicker]="graduationDatePicker" formControlName="graduationDate">
                      <mat-datepicker-toggle matSuffix [for]="graduationDatePicker"></mat-datepicker-toggle>
                      <mat-datepicker #graduationDatePicker></mat-datepicker>
                      <mat-hint>Format mm/dd/yyyy</mat-hint>
                      <mat-error>Please enter valid Actual/anticipated
                        graduation date</mat-error>
                    </mat-form-field>
                    <span class="mat-hint-italic margin-notop">This can be a future date for anticipated
                      graduation.<br />
                      <ul class="has-no-padding has-no-margin">
                        <li><strong>Did not finish your course?</strong> Select the date you last attended the
                          institution.
                        </li>
                        <li><strong>Can't remember this date?</strong> Select the first day of the month in the year you
                          got your degree.</li>
                      </ul>
                    </span>
                  </p>
                </ng-template>

                <div *ngIf="this.educationData.jobCountryId == 78">
                  <p class="bofa--heading is-8 bold ">(4 of {{count}}) Accepted Documentation</p>                 
                  <div class="width_50_padding-left_5">
                    <mat-form-field class="max-zoom field-space width_350" hideRequiredMarker>
                      <mat-label><abbr title="required">* </abbr>Accepted Documentation for Each Education Listed</mat-label>
                      <mat-select required formControlName="attachmentTypeId" [disabled]="educationForm.controls.mongoAttachmentId.value !=''">
                        <mat-option>Select</mat-option>
                        <mat-option *ngFor="let a of educationData.gbsEducationHisProofAttachmentList" [value]=a.attachmentId>
                          {{a.attachmentName}}
                        </mat-option>
                      </mat-select>
                      <mat-error>Please select Accepted Documentation</mat-error>
                    </mat-form-field>
                  </div>
                  <div class="width_50_padding-left_5">
                    <button type="button" class="float_right" class="bofa--button secondary" [disabled]="educationForm.controls.mongoAttachmentId.value !=''"
                    (click)="openFileDialog(true ,educationForm.controls.attachmentTypeId.value)">Attach</button>
                  </div>
                </div>

                <div class="is-taller remove-button-align">
                  <button type="button" class="bofa--button primary outlined" (click)="deleteClick(i)">Remove this
                    institution</button>
                </div>

              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </div>       
      </div>

      <!-- horizonally -->
      <div  class="fx-flex-60">
        <div [class.sticky]="sticky" class="width_535" [style.overflow]="auto" #stickyDiv>
          <div class="is-taller">
            <div class="level">
              <div class="width_50_padding-left_5">
                <h2 id="review-horizontal" class="bofa--heading is-6">Review your education history</h2>
              </div>
              <div class="width_50_padding-left_5" (click)="scroll(target)"> <button
                  [disabled]="educationList.invalid" type="button" class="float_right" class="bofa--button secondary"
                  (click)="onAddEducation()" #addButtonElement>Add institution</button>
              </div>
            </div>
          </div>
          <div>
            <mat-selection-list aria-disabled="false" *ngIf="listCheck" aria-label="Education History Selection List" aria-describedby="review-horizontal"
              (selectionChange)="handleSelection($event)">
              <mat-list-option *ngFor="let educationForm of educationList.controls; let i = index" [value]="i"
                [selected]="step === i" (click)="scroll(target)" (click)="focusTarget()" (keyup.enter)="focusTarget()" 
                (keyup.enter)="scroll(target)">
                <div class="is-taller">
                  <div class="level">

                    <div class="width_5_padding-left_5_margin-right_5"><span *ngIf="!educationForm.invalid">
                        <img src="assets/bofa_icon_checkmark2.svg" class="review-icon"
                          alt="check completed education" role="img" /></span>
                      <span *ngIf="educationForm.invalid">
                        <img src="assets/bofa_icon_alert.svg" class="review-icon" alt="error incomplete education" role="img" />
                      </span>
                      <span class="padding-left_10">{{i+1}}</span>
                    </div>
                    <div class="width_35_max-width_40_overflow_hidden_white-space_nowrap_padding-left_10">
                      {{educationForm.controls.educationInstitutionName.value | slice:0:20}}
                    </div>
                    <div class="width_45_padding-left_10_padding-top_5_padding-bottom_5">
                      {{educationForm.controls.educationStartDate.value | dateFormat }} <span
                        > <span
                          *ngIf="educationForm.controls.educationEndDate.value!=null"> -
                        </span>{{educationForm.controls.educationEndDate.value | dateFormat }} </span>
                    </div>
                  </div>
                </div>
                <mat-divider></mat-divider>
              </mat-list-option>
            </mat-selection-list>
          </div>
        </div>
      </div>
    
    </div>     
    <!-- needed for skip content off focus -->
    <div *ngIf="noEducationHistory.value">
      <div class="unClickableDiv">
        <input tabindex="-1" type="text" class="trasparentText">
      </div>
    </div>
    <div class="table-container bottom-space"  *ngIf="this.educationData.jobCountryId == 78 && !noEducationHistory.value">
      <span class="hide" id="tableDesc">Attached files</span>
      <table mat-table aria-labelledby="tableDesc" [dataSource]="dataSource">
        <ng-container matColumnDef="fileName">
          <th scope="col" class="cell-width" mat-header-cell *matHeaderCellDef>File Name</th>
          <td mat-cell *matCellDef="let element">
            <button type="button" class="bofa--button secondary outlined" title="Download Attachment {{element.fileName}}" 
            aria-label="download {{element.fileName}}" 
            (click)="downloadAttachment(element.mongoAttachmentId, element.fileName)">{{element.fileName}}
            </button>              
          </td>
        </ng-container>

        <ng-container matColumnDef="descOfFileName">
          <th scope="col" class="cell-width" mat-header-cell *matHeaderCellDef>Description</th>
          <td mat-cell *matCellDef="let element"> {{element.descOfFileName}}</td>
        </ng-container>

        <ng-container matColumnDef="fileType">
          <th scope="col" mat-header-cell *matHeaderCellDef>Type</th>
          <td mat-cell *matCellDef="let element"> {{element.fileType}} </td>
        </ng-container>

        <ng-container matColumnDef="fileSize">
          <th scope="col" class="cell-width" mat-header-cell *matHeaderCellDef>Size (In Bytes)</th>
          <td mat-cell *matCellDef="let element"> {{element.fileSize}} </td>
        </ng-container>

        <ng-container matColumnDef="attachedBy">
          <th scope="col" class="cell-width" mat-header-cell *matHeaderCellDef>Attached by</th>
          <td mat-cell *matCellDef="let element"> {{element.attachedBy}} </td>
        </ng-container>

        <ng-container matColumnDef="attachedDateString">
          <th scope="col" class="cell-width" mat-header-cell *matHeaderCellDef>Date attached</th>
          <td mat-cell *matCellDef="let element"> {{element.attachedDateString}} </td>
        </ng-container>
        <ng-container matColumnDef="remove">
          <th scope="col" class="text-center" mat-header-cell *matHeaderCellDef>Action</th>
          <td class="text-center" mat-cell *matCellDef="let element"> <span role="button" *ngIf="!formSubmitted"
              tabindex="0" (click)="removeAttachment(element.mongoAttachmentId,element.typeOfAttachmentId)"
              (keyup.enter)="removeAttachment(element.mongoAttachmentId,element.typeOfAttachmentId)"
              class="af-anchor">
              Remove <span class="hide">&nbsp;{{ element.fileName }}</span></span></td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns ; "></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <mat-paginator aria-label="Attached files pagination" [pageSizeOptions]="[ 10, 20 ]" showFirstLastButtons></mat-paginator>
    </div>  
  </form>
</div>

<ng-template #loading>
  Loading Education history...
</ng-template>
